// extracted by mini-css-extract-plugin
export default {"responsiveVideo":"ShakaPlayer_responsiveVideo__JJLfu"};